<template>
  <DashboardBlock title="Открытые проекты" class="dashboard-block__wrapper">
    <template slot="content">
      <Preloader v-if="isLoading" type="small" class="content__preloader" />
      <div v-else-if="projects.length > 0" class="content__list_projects vert-scroll">
        <div
          v-for="project in projects"
          :key="project.id"
          class="list__row"
          :class="getProjectCss(project)"
        >
          <div class="row__section_name">
            <router-link
              class="section__icon_project"
              :to="`/projects/${project.id}`"
              target="_blank"
            >
              <i class="fa fa-link" />
            </router-link>
            <div class="section__text_name">
              <span class="text__title">{{ project.name }}</span>
              <span class="text__subtitle">
                Изделий: {{ project.total_count }}
              </span>
            </div>
          </div>
          <div class="row__section_dates">
            <span>Дата создания: {{ formatDate(project.created_at) }}</span>
            <span>Дата сдачи: {{ formatDate(project.deadline_datetime) }}</span>
          </div>
        </div>
        <div v-if="projects.length < totalRecords" class="row__button_show-more">
          <button
            class="btn"
            :disabled="projectsAreUpdating"
            @click="currentPage++"
          >
            Больше записей <i class="fa fa-fw fa-angle-down" />
          </button>
        </div>
      </div>
      <div v-else class="content__list_empty">
        <span>
          На данный момент у вас нет проектов, находящихся в работе
        </span>
      </div>
    </template>
  </DashboardBlock>
</template>

<script>
import DashboardBlock from '@/_shared/components/ui/DashboardBlock';
import ShiftsCalendar from '@/_shared/features/work-shift-menu/ShiftsCalendar';
import Preloader from '@/_shared/components/ui/Preloader';
import { projectService } from '@/_shared/api-services';
import { formats } from "@/_shared/constants";
export default {
  components: {
    ShiftsCalendar,
    DashboardBlock,
    Preloader,
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      totalRecords: 0,
      projects: [],
      projectsAreUpdating: false,
    };
  },
  async created() {
    this.isLoading = true;
    await this.getProjects().then(() => {
      this.isLoading = false;
    });
  },
  watch: {
    async currentPage() {
      await this.getProjects();
    },
  },
  methods: {
    async getProjects() {
      this.projectsAreUpdating = true;
      await projectService.getAllOpen(this.currentPage).then((response) => {
        const { records, results } = response.data;
        this.projects = [...this.projects, ...records];
        this.totalRecords = results;
        this.projectsAreUpdating = false;
      });
    },
    formatDate(value = '') {
      const localizedDate = new Date(value);
      const result = localizedDate.toLocaleString('ru', formats.dates.deadline);
      return result;
    },
    getProjectCss(project = {}) {
      const withReachedDeadline = this.deadlineWasReached(project);
      const classes = {
        'list__row_deadline-reached': withReachedDeadline,
        'list__row_in-work': !withReachedDeadline,
      };
      return classes;
    },
    deadlineWasReached(project = {}) {
      const date = project.deadline_datetime;
      const deadlineTimestamp = new Date(date).getTime();
      const currentTimestamp = Date.now();
      return !!(currentTimestamp > deadlineTimestamp);
    },
  },
};
</script>

<style scoped>
.dashboard-block__wrapper {
  --wrapper-height: 350px;
  --main-color: #08c;
  --reached-deadline-color: rgb(189, 77, 92);
}
@keyframes on-list-update {
  0% {
    transform: translateY(10em);
    opacity: 0;
  }
  100% {
    transofrm: translateY(0);
    opacity: 1;
  }
}
.content__list_projects .list__row {
  animation: on-list-update 0.35s;
  display: flex;
  cursor: default;
  justify-content: space-between;
  border-bottom: 1px var(--main-color) solid;
  padding: 1em 1em 1em 0;
}
.content__preloader {
  padding-top: 1em;
  height: 100%;
  min-height: var(--wrapper-height);
}
.row__section_name {
  display: inline-flex;
  flex-direction: row;
}
.section__text {
  font-weight: 700;
}
.section__text,
.row__section_dates {
  display: flex;
  flex-direction: column;
}
.section__icon_project:focus,
.section__icon_project:hover {
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
  text-decoration: none;
}
.section__icon_project {
  margin-right: 0.5em;
  padding: 6px 14px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}
.list__row_in-work .section__icon_project {
  background: var(--main-color);
}
.list__row_deadline-reached .section__icon_project {
  background: var(--reached-deadline-color);
}
.list__row_deadline-reached .section__text_name {
  color: var(--reached-deadline-color);
}
.section__icon_project .fa-link {
  color: #fff;
}
.list__row_deadline-reached .text__title::after {
  content: ' (просрочен)';
  height: auto;
  width: auto;
}
.content__list_projects {
  padding-right: 1.5em;
  max-height: var(--wrapper-height);
  overflow-y: auto;
  overflow-x: hidden;
}
.row__section_dates {
  color: #57606a;
  font-size: 0.9em;
}
.content__list_empty {
  width: 100%;
  min-height: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.section__text_name .text__subtitle {
  font-size: 0.9em;
  color: #868686;
  font-weight: 500;
}
.section__text_name {
  text-align: left;
  display: inline-flex;
  flex-direction: column;
}
.section__text_name span {
  font-weight: 700;
}
.row__button_show-more {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5em;
}
.row__button_show-more > button {
  background: transparent;
  color: var(--main-color);
  border: 1px var(--main-color) solid;
}
.row__button_show-more > button:hover,
.row__button_show-more > button:focus {
  text-decoration: none;
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
}
@media (max-width: 1279px) {
  .content__list_projects,
  .content__list_empty {
    min-height: var(--wrapper-height);
  }
}
@media (max-width: 767px) {
  .content__list_projects .list__row {
    justify-content: center;
    flex-direction: column;
  }
  .row__section_name {
    margin-bottom: 1em;
    justify-content: center;
  }
  .content__list_projects {
    padding-right: 0.5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/user/components/personal-area/ProjectsBlock.vue